import { atom } from 'nanostores'

export const $pageContext = atom<null | { initial_theme: number }>(null)
